<div *ngIf="showAssignToMe()" class="assign-to-me-container">
    <button [id]="buttonId" [disabled]="loadingSpinner()" type="button" class="btn btn-primary" (click)="assignToMe(orderId)">
        <span>{{ !loadingSpinner() ? ('Orders.AssignToMe' | translate) : ('Orders.Assigning' | translate) + '...' }}</span>
    </button>
</div>
